<template>
    <div class="tooltip">
        <div class="tooltip-body fs-15 text-center">
            <slot />
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.tooltip {
    @include size(18px);
    @include border-circle();
    background-color: $color-bg-light;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;

    &:after {
        content: 'i';
        color: #b6b6b6;
        display: block;
        text-align: center;
        width: 100%;
        font-size: 1.3rem;
    }

    &-body {
        @include hide();
        @include border-radius(5px);
        @include transform(translateY(10px));
        @include transition(.1s);
        background-color: $color-primary;
        color: $color-default-contrast;
        position: absolute;
        padding: 15px 15px;
        width: 250px;
        bottom: calc(100% + 10px);
        left: -116px;

        &:after {
            content: '';
            border-color: $color-primary transparent transparent transparent;
            position: absolute;
            border-style: solid;
            border-width: 5px;
            margin: 0 0 0 -5px;
            top: 100%;
            left: 50%;
        }
    }

    &:hover & {
        &-body {
            @include show();
            @include transform-none();
        }
    }

    @media (max-width: $screen-mobile-landscape) {
        &-body {
            left: auto;
            right: 0;

            &:after {
                left: auto;
                right: 3px;
            }
        }
    }
}
</style>
